import React from "react";
import { Row, Col } from "reactstrap";
import EnhancedContentSection from "./../../../components/common/enhanced-content-section";
import items from "./items";
import "./details.scss";
import PageTagging from "components/common/page-tagging/page-tagging";
import { Link } from "react-router-dom";

const ServicesLandingPage = ({ showPageTitle }) => {
  const showTitle =
    showPageTitle === undefined || showPageTitle === true ? true : false;

  return (
    <>
      <PageTagging
        title="Services | Traffic Equipment Hire | VMS, Arrow Boards | TMA Hire"
        description="We provide a wide range of specialised traffic equipment hire products across Victoria. VMS Boards, Arrow Boards, Truck Mounted Attenuators and more"
      />

      {showTitle && (
        <section className="services-hero">
          <div className="services-hero-inner">
            <div className="services-hero-content">
              <span className="services-eyebrow">Our Services</span>

              <h1>
                Specialised Traffic Equipment <span>Hire Across Australia</span>
              </h1>

              <p>
                We provide a wide range of traffic management services across
                Victoria, Australia. This includes Variable Message Signs (VMS),
                Arrow Boards, Variable Speed Limit Signs (VSLS), Portable
                Traffic Lights, Truck Mounted Attenuator Trucks (TMA&apos;s),
                Traffic Utes, Highway Trucks. We also provide VMS repairs and
                maintenance services.
              </p>
            </div>

            <div className="services-hero-highlight">
              <div className="services-hero-icon">
                <i className="fas fa-road"></i>
              </div>

              <div>
                <span>Traffic Equipment Hire</span>

                <h3>Reliable Equipment. Professional Service.</h3>

                <p>
                  Supporting projects of all sizes with specialised traffic
                  equipment and responsive service.
                </p>
              </div>
            </div>
          </div>
        </section>
      )}

      <EnhancedContentSection isBlocking={false} showPageTitle={false}>
        {!showTitle && (
          <div className="services-intro-simple">
            <span className="services-eyebrow">Our Services</span>

            <h2>Traffic Equipment Hire</h2>

            <p>
              We provide a wide range of traffic management services across
              Victoria, Australia. This includes Variable Message Signs (VMS),
              Arrow Boards, Variable Speed Limit Signs (VSLS), Portable Traffic
              Lights, Truck Mounted Attenuator Trucks (TMA&apos;s), Traffic
              Utes, Highway Trucks. We also provide VMS repairs and maintenance
              services.
            </p>
          </div>
        )}

        <section className="services-list">
          <div className="services-section-heading">
            <span className="services-eyebrow">
              Traffic Equipment Solutions
            </span>

            <h2>Explore Our Services</h2>

            <p>Check out our services in more detail.</p>
          </div>

          <Row className="details">
            {items.map((item) => (
              <Col lg="4" md="6" xs="12" className="mb-4" key={item.id}>
                <Link to={item.link} className="service-card-link">
                  <article className="service-card">
                    <div
                      className="service-card-image"
                      style={{
                        backgroundImage: item.image,
                      }}
                    >
                      <div className="service-card-overlay"></div>
                    </div>

                    <div className="service-card-content">
                      <h3>{item.title}</h3>

                      <span className="service-card-action">
                        Learn More
                        <i className="fas fa-arrow-right"></i>
                      </span>
                    </div>
                  </article>
                </Link>
              </Col>
            ))}
          </Row>
        </section>
      </EnhancedContentSection>
    </>
  );
};

export default ServicesLandingPage;